import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import axios from "axios";
import { Star, Quote } from "lucide-react";
import { API } from "@/lib/api";

const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

const Stars = ({ n }) => (
  <div className="flex gap-1">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={15}
        strokeWidth={1.5}
        className={i <= n ? "fill-terracotta text-terracotta" : "text-sand"}
      />
    ))}
  </div>
);

export default function Avis() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/avis`).then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data || !data.avis.length) return null;

  return (
    <section data-testid="avis-section" className="border-t border-sand bg-[#F1EAE0]">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32">
        <Reveal>
          <p className="eyebrow">Ils ont brunché avec nous</p>
          <div className="mt-4 flex flex-wrap items-end gap-6">
            <h2 className="display-hero max-w-2xl text-4xl sm:text-5xl">
              Des matinées <span className="italic text-terracotta">dont on se souvient.</span>
            </h2>
            <div data-testid="avis-aggregate" className="flex items-center gap-3 pb-2 text-sm font-semibold text-espresso">
              <Stars n={Math.round(data.moyenne)} />
              {String(data.moyenne).replace(".", ",")}/5 · {data.total} avis
            </div>
          </div>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {data.avis.map((a, i) => (
            <Reveal key={`${a.nom}-${a.ville}`} delay={0.06 * i}>
              <figure
                data-testid={`avis-card-${i}`}
                className="flex h-full flex-col rounded-2xl border border-sand bg-cream p-7 transition-transform duration-500 hover:scale-[1.01]"
              >
                <Quote size={22} strokeWidth={1.25} className="text-terracotta/50" />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-espresso/80">{a.texte}</blockquote>
                <figcaption className="mt-6 flex items-center justify-between border-t border-sand pt-5">
                  <div>
                    <p className="text-sm font-semibold">{a.nom}</p>
                    <p className="text-xs text-clay">{a.ville}</p>
                  </div>
                  <Stars n={a.note} />
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
